export default __webpack_public_path__ + "media/zurb/img/home/facebook-icon-49fa26a0c15cf48ab9f4c513f85bb4c0.svg";